/* eslint-disable */
import store from "../../store";
/**
type PermissionType = {
  authority: string;
  children?: PermissionType[];
  display: string;
  error: string;
  flag: number;
  id: number;
  module: string;
  pid: number;
  remark: string;
  type: string;
  url: string;
  verify: string;
};
*/

export class PermissionChecker {
  RequestPermissionMap = new Map();
  UserPermissionMap = new Map();

  setRequestPermissionMap(permissionList) {
    permissionList.forEach(p => {
      if (!!p.url) {
        this.RequestPermissionMap.set(p.url, p.authority);
      }
      if (!!p.children) {
        this.setRequestPermissionMap(p.children);
      }
    });
  }
  setUserPermissionMap(permissionList) {
    permissionList.forEach(p => {
      if (!!p.url) {
        this.UserPermissionMap.set(p.url, p.authority);
      }
      if (!!p.children) {
        this.setUserPermissionMap(p.children);
      }
    });
  }

  /** true mean has permission */
  checkRequest(requestLink) {
    if (this.RequestPermissionMap.size === 0) {
      const allPermissionList = store.state.home.permission;
      if (allPermissionList) {
        this.setRequestPermissionMap(allPermissionList);
      }
    }
    if (this.UserPermissionMap.size === 0) {
      const userPermissionList = store.state.home.userInfo? store.state.home.userInfo.authorities : null;
      if (userPermissionList) {
        this.setUserPermissionMap(userPermissionList);
      }
    }
    if (this.RequestPermissionMap.has(requestLink)) {
      const needPermission = this.RequestPermissionMap.has(requestLink);
      const hasPermission =
        !needPermission || this.UserPermissionMap.has(requestLink);
      return hasPermission;
    }
    return true;
  }
}
